import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@chakra-ui/react';

import { BaseModal } from '../../modals';
import { useNabanStoreSelectedGlossaryModalKey, useNabanStoreSetGlossaryModalKey } from '../store';
import type { GlossaryKey } from './types';

type ModalContent = {
  title: string;
  body: string;
};

type Props = {
  onModalOpened?: (params: { name: GlossaryKey }) => void;
};

export const NabanGlossaryModal = ({ onModalOpened }: Props) => {
  const { t } = useTranslation('naban');

  const selectedGlossaryModalKey = useNabanStoreSelectedGlossaryModalKey();
  const setGlossaryModalKey = useNabanStoreSetGlossaryModalKey();

  const glossaryContent = useMemo<ModalContent | null>(() => {
    const content: Record<GlossaryKey, ModalContent> = {
      instrumentingOffice: {
        title: t('deed.details.instrumentingOffice.title'),
        body: t('glossary.instrumentingOffice'),
      },
      minuteHolderOffice: {
        title: t('deed.details.minuteHolderOffice.title'),
        body: t('glossary.minuteHolderOffice'),
      },
      minuteHolder: {
        title: t('deed.details.minuteHolder.title'),
        body: t('glossary.minuteHolder'),
      },
      penHolder: {
        title: t('deed.details.penHolder.title'),
        body: t('glossary.penHolder'),
      },
      interveningNotaries: {
        title: t('deed.details.interveningNotary.title'),
        body: t('glossary.interveningNotaries'),
      },
    };

    if (selectedGlossaryModalKey == null) {
      return null;
    }

    onModalOpened?.({ name: selectedGlossaryModalKey });

    return content[selectedGlossaryModalKey] ?? null;
  }, [selectedGlossaryModalKey, t, onModalOpened]);

  if (glossaryContent == null) {
    return null;
  }

  return (
    <BaseModal
      onClose={() => setGlossaryModalKey(null)}
      title={glossaryContent.title}
      RenderBody={<Text variant='tableCell'>{glossaryContent.body}</Text>}
    />
  );
};
